import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { ClientService } from '@dss-libs/shared/data-access/clients';

export const SubscriptionGuard: CanActivateFn = () => {
  const clientService = inject(ClientService);
  const clientDataResource = clientService.clientDataResource;
  return toObservable(clientDataResource.status).pipe(
    filter((status) => status === 'resolved' || status === 'error'),
    take(1),
    map(() => {
      if (!clientDataResource.hasValue()) return false;
      const client = clientDataResource.value();
      if (!client.subscriptionId) clientService.showSubscriptionModal.set(true);
      return true;
    })
  );
};
